import { render, staticRenderFns } from "./CaseBase.vue?vue&type=template&id=daee00de&scoped=true&"
import script from "./CaseBase.vue?vue&type=script&lang=js&"
export * from "./CaseBase.vue?vue&type=script&lang=js&"
import style0 from "./CaseBase.vue?vue&type=style&index=0&id=daee00de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daee00de",
  null
  
)

export default component.exports